import * as React from 'react'
import {
  CTASecondary,
  NavButton,
  CTAPrimary
} from '../components/shared/buttons'
import styled from 'styled-components'
import { Container, Row, Col, Hidden, config } from 'react-awesome-styled-grid'
import type { AppStateType } from '../reducers/appstate'
import type { Dispatch } from 'redux'
import { withRouter } from 'next/router'
import { connect, useSelector } from 'react-redux'
import {
  openBlogPage,
  openHome,
  signIn,
  openSubscribe, openDiscover
} from '../actions/navigationActions'
import { DipseaLogo } from '../components/shared/icons/DipseaLogo'
import { colors } from '../components/shared'
import { signOut } from '../actions/userActions'

type SimpleNavButtonOptionsType =
  | 'why-dipsea'
  | 'free-trial'
  | 'sign-in'
  | 'sign-out'
  | 'listen'
  | 'listen-white'
type PropsType = {
  loggedIn: boolean,
  backgroundColor?: string,
  buttonOrder?: SimpleNavButtonOptionsType[],
  buttonUtm?: string,
  isCenteredOnMobile: boolean
}

type DispatchPropsType = {
  openBlogPage: (page: string) => any,
  logOut: () => void,
  openHomePage: () => void,
  signIn: () => void,
  openSubscribe: () => void,
  openDiscover: () => void
}

function SimpleNav (props: PropsType & DispatchPropsType): React.ReactNode {
  const subscriptionCta = useSelector((state: AppStateType): string => state.subscriptionCTA)
  return (
    <NavContainer backupBackgroundColor={props.backgroundColor}>
      <Container>
        <Row>
          <Col>
            <NavInnerContainer isCenteredOnMobile={props.isCenteredOnMobile}>
              <Hidden xs={true} sm={true} md={true}>
                <HomeButton
                  onClick={(): void => props.openHomePage()}
                  aria-label='Dipsea, opens homepage'
                >
                  <DipseaLogo />
                </HomeButton>
              </Hidden>

              <Hidden lg={true} xl={true}>
                <HomeButton
                  onClick={(): void => props.openHomePage()}
                  aria-label='Dipsea, opens homepage'
                >
                  <DipseaLogo size={110} />
                </HomeButton>
              </Hidden>

              <ButtonsContainer>
                {props.buttonOrder &&
                  props.buttonOrder.map(
                    (button: SimpleNavButtonOptionsType): any => {
                      if (button === 'why-dipsea' && !props.loggedIn) {
                        return (
                          <React.Fragment key={button}>
                            <DynamicBtnText className='desktop'>
                            <CTASecondary
                              key={button}
                              minWidth='100px'
                              padding='11px 15px'
                              hoverOpacity
                              onClick={(): void =>
                                props.openBlogPage('dipsea-faq')
                              }
                            >
                              Why Dipsea?
                            </CTASecondary>
                            </DynamicBtnText>
                            <DynamicBtnText className='mobile'>
                              <CTASecondary
                                key={button}
                                minWidth='100px'
                                padding='11px 15px'
                                hoverOpacity
                                onClick={(): void =>
                                  props.openBlogPage('dipsea-faq')
                                }
                              >
                                Why Dipsea?
                              </CTASecondary>
                            </DynamicBtnText>
                          </React.Fragment>
                        )
                      } else if (button === 'sign-in' && !props.loggedIn) {
                        return (
                          <React.Fragment key={button}>
                            <DynamicBtnText className='desktop'>
                              <NavButton
                                key={button}
                                minWidth='132px'
                                hoverOpacity
                                onClick={props.signIn}
                              >
                                SIGN IN
                              </NavButton>
                            </DynamicBtnText>
                            <DynamicBtnText className='mobile'>
                              <NavButton
                                key={button}
                                minWidth='100px'
                                hoverOpacity
                                onClick={props.signIn}
                              >
                                SIGN IN
                              </NavButton>
                            </DynamicBtnText>
                          </React.Fragment>
                        )
                      } else if (button === 'sign-out' && props.loggedIn) {
                        return (
                          <React.Fragment key={button}>
                            <DynamicBtnText className='desktop'>
                              <CTASecondary
                                key={button}
                                minWidth='132px'
                                padding='11px 15px'
                                hoverOpacity
                                onClick={props.logOut}
                              >
                                SIGN OUT
                              </CTASecondary>
                            </DynamicBtnText>
                            <DynamicBtnText className='mobile'>
                              <CTASecondary
                                key={button}
                                minWidth='100px'
                                padding='5px 5px'
                                hoverOpacity
                                onClick={props.logOut}
                                height={'30px'}
                              >
                                SIGN OUT
                              </CTASecondary>
                            </DynamicBtnText>
                          </React.Fragment>
                        )
                      } else if (button === 'free-trial' && !props.loggedIn) {
                        return (
                          <React.Fragment key={button}>
                            <DynamicBtnText className='desktop'>
                              <CTAPrimary
                                minWidth='132px'
                                className={'subscribe-cta'}
                                hoverOpacity
                                onClick={(): void => props.openSubscribe()}
                              >
                                {subscriptionCta}
                              </CTAPrimary>
                            </DynamicBtnText>
                            <DynamicBtnText className='mobile'>
                              <CTAPrimary
                                minWidth='132px'
                                hoverOpacity
                                className={'subscribe-cta'}
                                onClick={(): void => props.openSubscribe()}
                              >
                                {subscriptionCta}
                              </CTAPrimary>
                            </DynamicBtnText>
                          </React.Fragment>
                        )
                      } else if (button === 'listen') {
                        return (
                          <React.Fragment key={button}>
                            <DynamicBtnText className='desktop'>
                              <CTAPrimary
                                minWidth='132px'
                                hoverOpacity
                                onClick={(): void => props.openDiscover()}
                              >
                                LISTEN
                              </CTAPrimary>
                            </DynamicBtnText>
                            <DynamicBtnText className='mobile'>
                              <CTAPrimary
                                minWidth='50px'
                                hoverOpacity
                                onClick={(): void => props.openDiscover()}
                                height={'30px'}
                                padding={'0px 10px'}
                              >
                                LISTEN
                              </CTAPrimary>
                            </DynamicBtnText>
                          </React.Fragment>
                        )
                      } else if (button === 'listen-white') {
                        return (
                          <React.Fragment key={button}>
                            <DynamicBtnText className='desktop'>
                              <CTASecondary
                                minWidth='50px'
                                hoverOpacity
                                onClick={(): void => props.openDiscover()}
                              >
                                LISTEN
                              </CTASecondary>
                            </DynamicBtnText>
                            <DynamicBtnText className='mobile'>
                              <CTASecondary
                                minWidth='132px'
                                hoverOpacity
                                onClick={(): void => props.openDiscover()}
                              >
                                LISTEN
                              </CTASecondary>
                            </DynamicBtnText>
                          </React.Fragment>
                        )
                      }
                      return null
                    }
                  )}
              </ButtonsContainer>
            </NavInnerContainer>
          </Col>
        </Row>
      </Container>
    </NavContainer>
  )
}

const HomeButton = styled.button<any>`
  outline: none;
  padding: 0;
  margin: 6px 0 0 -1px;
  background: none;
  cursor: pointer;
  border: 1px solid transparent;
  transition: border-bottom 0.25s;
  :focus-visible {
    border-bottom: 1px solid ${colors.sand};
  }
`

const NavContainer = styled.div<any>`
  position: sticky;
  width: 100%;
  left: 0px;
  top: 0px;
  z-index: 2;
  height: 60px;
  ${(props: any): any => config(props).media.md`
    height: 75px;
  `}

  display: flex;
  align-items: center;
  background: ${(props: { backupBackgroundColor: string | null | undefined }): string =>
    props.backupBackgroundColor
      ? props.backupBackgroundColor
      : colors.midnightBlue90};
  @supports (backdrop-filter: none) {
    background: rgba(0, 0, 0, 0.03);
    backdrop-filter: blur(80px);
  }
`

const ButtonsContainer = styled.div<any>`
  display: flex;
  gap: 8px;
  ${(props: any): any => config(props).media.md`
    position: absolute;
    right: 60px;
 `}
`

const NavInnerContainer = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: ${(props: any): string => props.isCenteredOnMobile ? 'center' : 'space-between'};
  width: 100%;
  height: 100%;
  ${(props: any): any => config(props).media.lg`
    justify-content: center;
  `}
`

const DynamicBtnText = styled.div<any>`
  &.desktop {
    display: none;
  }
  ${(props: any): any => config(props).media.lg`
    &.mobile {
      display: none;
    }
    &.desktop {
      display: block;
    }
  `}
`

const mapStateToProps = (
  state: AppStateType,
  ownProps: { backgroundColor?: string, isCenteredOnMobile?: boolean }
): PropsType => {
  return {
    loggedIn: !!(state.user || {}).id,
    backgroundColor: ownProps.backgroundColor,
    isCenteredOnMobile: !!ownProps.isCenteredOnMobile
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchPropsType => {
  return {
    openBlogPage: (page: string): void => dispatch(openBlogPage(page)),
    logOut: (): void => dispatch(signOut()),
    openHomePage: (): void => dispatch(openHome()),
    signIn: (): void => dispatch(signIn()),
    openSubscribe: (): void => dispatch(openSubscribe()),
    openDiscover: (): void => dispatch(openDiscover())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SimpleNav)
) as any
